import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import './Connection.scss'

import Grid from '@material-ui/core/Grid'
import EurestoLogo from 'EurestoStyle/font/euresto_01.png'

const project = require('EurestoConfig/project.config')

class Connection extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      heightPanel: 0,
      messageErreur: [],
      passwordForgot: props.passwordForgot
    }
  }

  handleClick = async () => {
    if ($('#email').val() === '' || $('#email').val() === undefined) {
      this.setState({
        messageErreur: ['Veuillez saisir votre adresse email.']
      })
      return
    }
    if ($('#password').val() === '' || $('#password').val() === undefined) {
      this.setState({
        messageErreur: ['Veuillez saisir votre mot de passe.']
      })
      return
    }
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'login',
      email: $('#email').val(),
      password: $('#password').val()
    }, { returnAnyway: true })
    if (result.code === 1) {
      this.props.handler(result.token)
    } else {
      this.setState({
        messageErreur: [result.message]
      })
    }
  }

  componentDidMount () {
    this.setState({
      heightPanel: $('#ConnectionEurestoPanel').height()
    })
  }

  deleteMessageErreur = _ => {
    this.setState({
      messageErreur: []
    })
  }

  sendEmail = async _ => {
    const result = await ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'forgot_password',
      email: $('#email').val(),
    }, { returnAnyway: true })

    if (result && result.code === 1) {
      this.setState({
        emailSend: true
      })
    } else {
      this.setState({
        messageErreur: [result.message]
      })
    }
  }

  render () {
    const { passwordForgot, emailSend } = this.state
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100vh' }} direction="column" justify="center"
            alignItems="center" className="EurestoBodyConnection grad">


        <Grid id={'ConnectionEurestoPanel'} item style={{
          margin: 0, padding: 0, position: 'relative',
          zIndex: 11,
        }} lg={2} md={4} sm={4} xs={6}
              onKeyPress={(e) => {
                if (e.charCode === 13) {
                  !passwordForgot ? this.handleClick() : this.sendEmail()
                } else if (this.state.messageErreur.length > 0) this.deleteMessageErreur()
              }}>

          <Grid container style={{
            margin: 0,
            padding: 0,
            height: 'auto',
            zIndex: 11,
            position: 'absolute',
            bottom: $('#ConnectionEurestoPanel').innerHeight(),
            fontSize: 20, width: '100%', textAlign: 'center'
          }} direction="column" justify="center" alignItems="stretch">
            {
              this.state.messageErreur.map((msg, i) => (
                <div className={'EurestoText--text EurestoError'} style={{
                  width: '100%',
                  padding: 5,
                  fontSize: 12,
                  marginBottom: 15,
                  textAlign: 'justify',
                  position: 'relative',
                  borderRadius: 10
                }}>{msg}
                </div>
              ))
            }
          </Grid>
          {!emailSend && <Grid container style={{
            zIndex: 10,
            margin: 0,
            padding: 0,
            position: 'relative',
            paddingBottom: passwordForgot && 20 || 5,
            textAlign: 'center',
            background: 'rgb(0, 36, 49)',
            borderRadius: '10px',
          }} direction="column" justify="center" alignItems="stretch">
            {passwordForgot && !this.props.passwordForgot && <a onClick={_ => this.setState({
              passwordForgot: false,
            })} className={'cursor-pointer fa fa-2x fa-chevron ei-left EurestoText--text'}
                                  style={{ position: 'absolute', top: 10, left: 7 }}/>}
            <img alt='Bandeau euresto' width="100%" style={{ marginTop: 0, minHeight: '1%' }} src={EurestoLogo}/>
            {passwordForgot &&
            <span className={'EurestoText--text'}
                  style={{ fontSize: 12, textAlign: 'middle', padding: 15, paddingBottom: 0, fontWeight: 'lighter' }}>Veuillez confirmer votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.</span>}
            <Grid container style={{
              margin: '10px 10px 0px 10px', padding: 0,
              borderRadius: '5px', position: 'relative', width: 'calc(100% - 20px)',
              border: '3px solid rgb(0, 159, 132)',
            }} spacing={0} justify="center"
                  alignItems="center">

              <Grid container style={{
                margin: 0,
                padding: 0, width: '15%',
                backgroundColor: 'rgb(0, 36, 49)',
                borderRight: '3px solid rgb(0, 159, 132)',
                height: '40px',
              }} direction="column" justify="center" alignItems="stretch">
                <i className="ei-commun_action_mail fa-2x EurestoText--text"/>
              </Grid>
              <input style={{
                backgroundColor: 'white',
                color: 'black',
                marginTop: 0,
                height: '40px',
                width: '85%',
                fontSize: '18px',
              }} id="email" type="email"
                     autoFocus={true}
                     placeholder=" Votre Email"/>
            </Grid>
            {!passwordForgot && <Grid container style={{
              margin: '10px 10px 0px 10px', padding: 0,
              borderRadius: '5px', position: 'relative', width: 'calc(100% - 20px)',
              border: '3px solid rgb(0, 159, 132)',
            }} spacing={0} justify="center"
                                      alignItems="center">

              <Grid container style={{
                margin: 0,
                padding: 0,
                width: '15%',
                backgroundColor: 'rgb(0, 36, 49)',
                borderRight: '3px solid rgb(0, 159, 132)',
                height: '40px',
              }} direction="column" justify="center" alignItems="stretch">
                <i className="ei-commun_cadena_ferme fa-2x EurestoText--text"/>
              </Grid>
              <input style={{
                backgroundColor: 'white',
                color: 'black',
                marginTop: 0,
                width: '85%',
                height: '40px',
                fontSize: '18px',
              }} id="password" type="password"
                     placeholder=" Votre mot de passe"/>
            </Grid>}
            <button style={{
              border: '3px solid rgb(0, 159, 132)',
              backgroundColor: 'white',
              width: 'calc(100% - 20px)',
              height: '40px',
              borderRadius: '5px',
              fontSize: '18px',
              margin: '10px 10px 0px 10px'
            }}
                    onClick={!passwordForgot && this.handleClick || this.sendEmail}>{!passwordForgot && 'Se connecter' || 'Confirmer'}
            </button>
            {!passwordForgot && <span className={'EurestoText--text'} style={{ marginTop: 5, marginBottom: 2.5, fontWeight: 'bold', fontSize: 12, cursor: 'pointer' }}
                                      onClick={_ => this.setState({
                                        passwordForgot: true,
                                        messageErreur: []
                                      })}>Mot de passe oublié ?</span>}
          </Grid>
          ||
          <Grid container style={{
            zIndex: 10,
            margin: 0,
            padding: 0,
            position: 'relative',
            paddingBottom: 5,
            textAlign: 'center',
            background: 'rgb(0, 36, 49)',
            borderRadius: '10px',
          }} direction="column" justify="center" alignItems="stretch">
            {passwordForgot && <a onClick={_ => this.setState({
              passwordForgot: true,
              emailSend: false
            })} className={'cursor-pointer fa fa-2x fa-chevron ei-left EurestoText--text'}
                                  style={{ position: 'absolute', top: 10, left: 7 }}/>}
            <img alt='Bandeau euresto' width="100%" style={{ marginTop: 0, minHeight: '1%' }} src={EurestoLogo}/>
            <span style={{ margin: '5px 0px', fontWeight: 'bold', fontSize: 12 }}>Consultez votre boîte mail</span>
            <span className={'EurestoText--text'}
                  style={{ fontSize: 12, textAlign: 'middle', padding: 15, paddingBottom: 0, fontWeight: 'lighter' }}>Nous venons d'envoyer un lien de réinitialisation du mot de passe à l'adresse e-mail de {$('#email').val()}</span>
            {!this.props.passwordForgot && <span style={{ marginTop: 5, marginBottom: 2.5, fontWeight: 'bold', fontSize: 12 }}
                  onClick={_ => this.setState({
                    passwordForgot: false,
                    emailSend: false,
                    messageErreur: []
                  })}><a className={'EurestoText--text'} style={{ cursor: 'pointer' }}>Retourner à la page d'identification</a></span>}
          </Grid>}
        </Grid>

      </Grid>
    )
  }
}

export default Connection



// WEBPACK FOOTER //
// ./app/App/Page/Connection/index.js